import { ApiBaseService, IntegrationsServiceAPI } from '@/services/api.base.service';
import store from '@/store/store';
import {Integration, SuccessResponse, TestResult} from '@/types';

export interface CreateIntegrationResponse {
  success: boolean;
  integration: Integration;
}

export class IntegrationsService {
  private integrations: ApiBaseService;

  constructor() {
    this.integrations = IntegrationsServiceAPI;
  }

  public async getIntegrations(): Promise<Integration[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.integrations.get(`organisation/${organisationId}/integrations`);
  }

  public async getIntegrationById(integrationId: number): Promise<Integration> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.integrations.get(`organisation/${organisationId}/integrations/${integrationId}`);
  }

  public async createIntegration(body: Integration): Promise<CreateIntegrationResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.integrations.post(`organisation/${organisationId}/integrations`, body);
  }

  public async updateIntegration(body: Integration): Promise<CreateIntegrationResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.integrations.put(`organisation/${organisationId}/integrations/${body.id}`, body);
  }

  public async testIntegration(id: number): Promise<TestResult> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.integrations.get(`organisation/${organisationId}/integrations/${id}/test` );
  }

  public async deleteIntegration(integrationId: number): Promise<SuccessResponse> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.integrations.delete(`organisation/${organisationId}/integrations/${integrationId}`);
  }

}

export default new IntegrationsService();
